import { type FC } from "react";

import * as Styled from "./VolumeChart.styles";

const BARS = Array.from(
  { length: 90 },
  (_, index) =>
    30 + Math.round(Math.sin(index / 4.5) * 18 + Math.sin(index / 13) * 22)
);

export const VolumeChartSkeleton: FC = () => {
  return (
    <Styled.Root>
      <Styled.SkeletonBars>
        {BARS.map((height, index) => (
          <Styled.SkeletonBar key={index} $height={height} />
        ))}
      </Styled.SkeletonBars>
    </Styled.Root>
  );
};
